console.log("aserfwerwqre");

import React from "react";
import "./App.css";
import "./transformationRenderer.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import HomePage from "./Component/Home/HomePage";
import CredentialsPage from "./Component/SideData/Credentials/CredentialsPage";
import { ManageExtensions } from "./Component/SideData/Extensions/ManageExtensions";
import Signup from "./Component/Auth/Signup";
import Login from "./Component/Auth/Login";
import { AppDetailPage } from "./Component/SideData/Overview/AppDetailPage";
import AllWSChats from "./Component/all_chats/AllWSChats";
import { Header } from "./Component/Auth/Header/Header";
import { NewLogin } from "./Component/Auth/New Login/NewLogin";
import { NewSignup } from "./Component/Auth/NewSignup/NewSignup";

import { RootPage } from "./Component/SideData/AdminRoot/RootPage";
import CreateApp from "./Component/NewCreateAppF/CreateApp";
import Document from "./Component/Documentation";
import Pricing from "./Component/Pricing";
import Usage from "./Component/Usage";
import TestingCorsApis from "./Component/TestingCorsApis";

import RoadMap from "./Component/roadmap/RoadMap";

import { PlayGround } from "./Component/SideData/AdminRoot/PlagGround/PlayGround";
import RenderTest from "./RenderTest";
import ParentComp from "./Component/NewDocument/DocComp.js/ParentComp";
import TourToolTip from "./Component/TourToolTip";
import TourToolTip2 from "./Component/TourToolTip2";
import VerifyEmail from "./Component/VerifyEmail";
import MyProfilePage from "./Component/MyProfile/MyProfilePage";
import { FirstAppHeader } from "./Component/Header/FirstAppHeader";
import useIsMobile from "./Component/SideData/AdminRoot/useIsMobile";
import { MobileHeader } from "./Component/Header/MobileHeader";
import TermsAndConditions from "./Component/TermsAndConditions";

import ScheduleDemo from "./Component/ScheduleDemo";
import ScheduleDemoDetail from "./Component/ScheduleDemoDetail";

import Privacy from "./Component/Privacy";
import ForgotPassword from "./Component/ForgotPassword";
import ResetForgottenPwd from "./Component/ResetForgottenPwd";

import SupportQuery from "./Component/SupportQuery";
import PaymentsAndBillings from "./Component/PaymentsAndBillings";

import ChatNodeRenderer from "./Component/NewCreateAppF/ChatNodeRenderer";
import AnalyticsPanel from "./Component/AnalyticsPanel/AnalyticsPanel";
import CancellationRefundPolicy from "./Component/CancellationRefund";
import ShippingPolicy from "./Component/ShippingPolicy";
import ContactUs from "./Component/ContactUs";
import MyQNATest from "./Component/app_components/MyQNATest";
import SupportTicketDetail from "./Component/SupportTicketDetail";
import Settings from "./Component/Settings";
import DemoReduxComponent from "./Component/reduxTestingComp/DemoReduxComponent";
import {
  ChatBundleProvider,
  useChatBundleContext,
} from "../src/contexts/ChatBundleContext";
import ResetNewPassword from "./Component/ResetNewPassword";
import ResetPassword from "./Component/ResetPassword";

import { TourProvider } from "./contexts/TourContext";
import TourManager from "./Component/Tour/TourManager";
import ProductTour from "./Component/Tour/ProductTour";
import PreviewTester from "./Component/SideData/Overview/PreviewTesterHome/PreviewTester/PreviewTester";
import ResponseTemplates from "./Component/SideData/Overview/AiAgentWorkFlow/ResponseTemplates";
import TransformationPlayerTest from "./Component/SideData/Overview/TransformationLayerFlow/TransformationLayer/vanilaIndex";
import ChatTeardownOnRouteChange from "./Component/ChatTeardownOnRouteChange";
import OAuthFlowSuccess from "./Component/SideData/Overview/AiAgentWorkFlow/OAuthFlowSuccess";
import OAuthFlowError from "./Component/SideData/Overview/AiAgentWorkFlow/OAuthFlowError";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isMobile = useIsMobile();
  const isLoggedIn = localStorage.getItem("token");
  const hasUserInfo = localStorage.getItem("meData");
  const { loading: bundleLoading } = useChatBundleContext();

  return (
    <Route
      {...rest}
      render={({ location, ...props }) => {
        if (isLoggedIn && hasUserInfo && bundleLoading) {
          return (
            <div style={{ padding: 20, textAlign: "center", fontSize: "18px" }}>
              Loading chat...
            </div>
          );
        }

        return isLoggedIn && hasUserInfo ? (
          <div className="appWrap">
            <div className="render_header">
              <FirstAppHeader isMobile={isMobile} />
            </div>
            <div className="render_body">
              <Component {...props} />
            </div>
          </div>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

const App = () => {
  const isLoggedIn =
    localStorage.getItem("token") && localStorage.getItem("meData");

  console.log("how many times does it reload? and if loogedin");

  if (process.env.REACT_APP_STAGE_ENV === "dev") {
    localStorage.removeItem("tour_allApps_completed");
    localStorage.removeItem("tour_appDetail_completed");
  }

  return (
    <ChatBundleProvider>
      <TourProvider>
        <Router>
          <div>
            <ChatTeardownOnRouteChange />

            <Switch>
              <PrivateRoute exact path="/" component={HomePage} />
              <Route path="/header" component={Header} />
              <Route path="/login" component={NewLogin} />

              <Route path="/signup" component={NewSignup} />

              <Route path="/forgot_password" component={ForgotPassword} />
              <Route
                path="/reset_forgotten_password"
                component={ResetForgottenPwd}
              />

              <Route path="/reset_password" component={ResetPassword} />
              <Route path="/reset_new_password" component={ResetNewPassword} />
              <Route path="/testing_cors_apis1" component={TestingCorsApis} />

              <Route
                path="/terms_and_conditions_policy"
                component={TermsAndConditions}
              />

              <Route path="/oauth/success" component={OAuthFlowSuccess} />
              <Route path="/oauth/error" component={OAuthFlowError} />

              <Route path="/privacy_policy" component={Privacy} />
              <Route
                path="/cancellation_and_refund_policy"
                component={CancellationRefundPolicy}
              />
              <Route path="/shipping_policy" component={ShippingPolicy} />
              <Route path="/contact_us" component={ContactUs} />

              <Route path="/schedule_demo" component={ScheduleDemo} />
              <Route path="/testing_redux" component={DemoReduxComponent} />
              <Route
                path="/scheduled_demo/:demo_id"
                component={ScheduleDemoDetail}
              />

              <PrivateRoute
                path="/support/:ticket_id"
                component={SupportTicketDetail}
              />
              <PrivateRoute path="/support" component={SupportQuery} />
              <PrivateRoute path="/limits" component={Usage} />
              <PrivateRoute path="/settings" component={Settings} />
              <PrivateRoute path="/payments" component={PaymentsAndBillings} />

              <PrivateRoute path="/credentials" component={CredentialsPage} />
              <PrivateRoute
                path="/app_detail/:region/:app_name"
                component={AppDetailPage}
              />

              <PrivateRoute path="/all_chats" component={RootPage} />
              <PrivateRoute path="/example_load" component={RenderTest} />

              <Route path="/response_format_setter" component={PreviewTester} />
              <Route path="/playground" component={TransformationPlayerTest} />

              <Route path="/response_templates" component={ResponseTemplates} />
              <PrivateRoute path="/response_templates" component={ResponseTemplates} />

              <PrivateRoute path="/create_application" component={CreateApp} />
              <PrivateRoute path="/qna_test" component={MyQNATest} />
              <PrivateRoute path="/documentation" component={Document} />

              <PrivateRoute path="/pricing" component={Pricing} />
              <PrivateRoute path="/roadmap" component={RoadMap} />

              <Route path="/verify_email" component={VerifyEmail} />
              <PrivateRoute path="/my_profile" component={MyProfilePage} />
              <PrivateRoute path="/analytics" component={AnalyticsPanel} />

              <PrivateRoute path="/extensions" component={ManageExtensions} />
              <PrivateRoute path="/tour_tooltip" component={TourToolTip} />
              <PrivateRoute path="/tour_tooltip2" component={TourToolTip2} />

              <PrivateRoute path="/new_document" component={ParentComp} />
            </Switch>
          </div>
        </Router>
      </TourProvider>
    </ChatBundleProvider>
  );
};

export default App;